// extracted by mini-css-extract-plugin
export var arrows = "_53-5";
export var decrementer = "_53-9";
export var disabled = "_53-3";
export var error = "_53-1";
export var hiddenText = "_53-a";
export var incrementer = "_53-8";
export var input = "_53-7";
export var inputWrapper = "_53-0";
export var readonly = "_53-2";
export var regular = "_53-6";
export var small = "_53-4";